import { ConversationMessageType } from '../constants'
import { ConversationMessage } from '../types/conversation'
import { PostReplyNewResp } from '../types/post-reply'

export const transformPostReplyNewResp = (response: PostReplyNewResp): ConversationMessage => ({
  createdTime: response.created_at,
  entityType: ConversationMessageType.Message,
  message: {
    id: response.id,
    content: response.data.content,
    isSentFromMobile: false,
    photos: [],
    isHidden: false,
    userId: response.sender_id,
    safetyFlag: null,
  },
})
